<div class="d-flex flex-column align-items-center">
  <div><img alt="compagny logo" [src]="footerLogoUrl()" class="logo" /></div>
  <div class="text normal primary">{{ version }}</div>
</div>
